import { registerApplication, start, navigateToUrl } from "single-spa";
import { gmaps, connectionService } from '@leapsight/styleguide'


window.addEventListener('single-spa:routing-event', () => {
  const currentPath = window.location.pathname;

  if (!currentPath.startsWith('/portal/login')
      && !currentPath.startsWith('/portal/register')
      && !localStorage.getItem("ACCESS_TOKEN"))
    return navigateToUrl('/portal/login')


  const userIsAuthorized = !connectionService.getGroups().includes("business_account_report_user")

  if (currentPath.startsWith('/fleet-management') && !userIsAuthorized) {
    navigateToUrl('/portal');
  }
})

registerApplication({
  name: "@leapsight/portal",
  app: () => System.import("@leapsight/portal"),
  activeWhen: "/portal",
});

let liveTracking = async ()=> {
  await gmaps() // Espera a que cargue el mapa de google en window antes de cargar live tracking
  return registerApplication({
    name: "@leapsight/live-tracking",
    app: () => System.import("@leapsight/live-tracking"),
    activeWhen: "/live-tracking"
  })
}
  
liveTracking()

registerApplication({
  name: "@leapsight/fleet-management",
  app: () => System.import("@leapsight/fleet-management"),
  activeWhen: (location) => {
    if (!localStorage.getItem("ACCESS_TOKEN")) return false;
    const isFleetManagementRoute = location.pathname.startsWith("/fleet-management");

    const userIsAuthorized = !connectionService.getGroups().includes("business_account_report_user")

    return isFleetManagementRoute && userIsAuthorized;
  },
});

registerApplication({
  name: "@dwid/reports",
  app: () => System.import("@dwid/reports"),
  activeWhen: "/reports",
});
  
start();
let path = window.location.pathname;
path === "/" ? window.location.replace("/portal") : "";

